<app-error-page [errorMsg]="errorMsg" *ngIf="containsError"></app-error-page>

<div class="search-update-container" *ngIf="!containsError">

  <div class="pageHeader" id="loanListHeader">
    <span>List of Loans</span>
  </div>


  <div class="download-button">

    <div class="select-style">
      <fm-select
        [options]="pageView"
        placeholder="Choose"
        [(ngModel)]="selectedPageView"></fm-select>
    </div>
    <button fmButton class="ok-button" type="button" [small]="true" label="Ok" (click)='pageViewAction(dt)'></button>
   </div>

  <div class="page-description">
    1.Check the boxes under 'Delete'. Click the delete button to delete the loans that are selected.2. Click the Cancel button to return to the previous page.3. Click on the highlighted Loan Number to view the Loan Details.
  </div>

  <br>
  <div class="u-scroll-x" >

    <fm-table #dt [columns]="cols" [value]="showResult"
              [paginator]="true" [rows]="10"
              [compressed]="true" [autoLayout]="true" [exportFilename]="exportFilename"
              [rowsPerPageOptions]="[10,25,50]" [enableTableEntryTotal]="true">
      <ng-template fmTemplate="header" let-columns>
        <tr>
          <th *ngFor="let col of columns" class="row-selection">
            {{col.header}}
          </th>
        </tr>
      </ng-template>
      <ng-template fmTemplate="body" let-rowData let-columns="columns">
        <tr>
          <td class="td-content" *ngFor="let col of columns">
            <span *ngIf="col.header==='Lender Loan ID' || col.header==='Fanniemae Loan Number'">
              <a  (click)="showLoanDetails(rowData)"   class="detail-link">{{rowData[col.field]}} </a>
            </span>
              <span *ngIf="col.header!=='Lender Loan ID' && col.header!=='Fanniemae Loan Number'"> {{rowData[col.field]}}</span>

          </td>
        </tr>
      </ng-template>
    </fm-table>
  </div>
  <span></span>

  <div class="u-mb-150">
    <!-- <button *ngIf="this.responseLoanEntity" fmButton type="submit" [primary]="true" [small]="true" label="Select All"
            class="buttonmargin"></button>

    <button *ngIf="this.responseLoanEntity" fmButton type="button" [primary]="true" label="Unselect All" [small]="true" class="buttonmargin"></button>

    <button fmButton type="button" [primary]="true" label="Delete" [small]="true" class="buttonmargin"></button> -->

    <button fmButton type="button" [primary]="true" label="Cancel" [small]="true" routerLink="/searchupdateloan"
            class="buttonmargin"></button>

  </div>

</div>
